/**
 * @desc 导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.warehouseSku.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/warehouseSku/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
